import Avatar from "components/avatar";
import { useState, useRef, useEffect } from "react";
import { TiTick } from "react-icons/ti";

const HouseholdMultiSelect = ({
  currentUser,
  users,
  selectedMembers,
  setSelectedMembers,
}) => {

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  // const [selectedMembers, setSelectedMembers] = useState([]);

  const householdOptions = users
    ?.filter((u) => u.id !== currentUser?.id)
    .map((user) => ({
      id: user?.id,
      name: user?.firstName + " " + user?.lastName,
      role: user?.role,
      avatar: { url: user?.avatar?.url },
      email: user?.email,
      phone: user?.phone,
      isPrimary: user?.isPrimary || false,
      userDetails: {
        relationshipText: user?.relationshipText || "",
        schoolGrade: user?.schoolGrade || "",
        allergies: user?.allergies || [],
      },
    }));

  const dropdownRef = useRef(null);

  const handleSelectMember = (member) => {
    if (!selectedMembers.some((m) => m.id === member.id)) {
      setSelectedMembers([...selectedMembers, member]);
    } else {
      setSelectedMembers(selectedMembers.filter((m) => m.id !== member.id));
    }
  };

  const handleRemoveMember = (id) => {
    setSelectedMembers(selectedMembers.filter((m) => m.id !== id));
  };

  const isSelected = (id) => selectedMembers.some((m) => m.id === id);

  const filteredMembers = householdOptions.filter((member) =>
    member.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative w-full" ref={dropdownRef}>
      {/* Dropdown trigger */}
      <div
        className="border border-gray-300 rounded-xl p-3 cursor-pointer flex items-center justify-between flex-wrap gap-2"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        {selectedMembers?.length > 1 ? (
          selectedMembers
            ?.filter((m) => m.id !== currentUser?.id)
            ?.map((member) => (
              <div
                key={member?.id}
                className="flex items-center space-x-1 bg-gray-100 dark:bg-navy-700 px-2 py-1 rounded-md"
              >
                <Avatar size="xs" user={member} />
                <span className="text-sm">{member?.name}</span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveMember(member.id);
                  }}
                  className="text-gray-400 hover:text-red-500 text-xs ml-1"
                >
                  ✕
                </button>
              </div>
            ))
        ) : (
          <span className="text-gray-400">Select for someone</span>
        )}
        <span className="ml-auto text-gray-400">&#9662;</span>
      </div>

      {/* Dropdown content */}
      {dropdownOpen && (
        <div className="absolute z-10 bg-white dark:bg-navy-800 border border-gray-200 mt-2 rounded-xl w-full shadow-lg max-h-60 overflow-y-auto">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search for someone"
            className="w-full p-2 border-b border-gray-200 text-sm outline-none bg-white dark:bg-navy-800 dark:text-white"
          />
          {filteredMembers.length > 0 ? (
            filteredMembers.map((member) => (
              <div
                key={member.id}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelectMember(member);
                }}
                className="p-3 hover:bg-gray-100 dark:hover:bg-navy-700 cursor-pointer border-b border-gray-100 last:border-none"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <Avatar size="xs" user={member} />
                    <div>
                      <p className="text-[#2B3674] dark:text-white text-[14px]">
                        {member.name}
                      </p>
                      <p className="text-[12px] text-[#8F9BBA]">
                        {member.role}
                      </p>
                    </div>
                  </div>
                  {isSelected(member.id) && (
                    <div className="bg-[#91B9A8] p-1 rounded-full ml-5">
                      <TiTick className="text-white" />
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="p-3 text-sm text-gray-400">No members found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default HouseholdMultiSelect;
